<template>
    <v-card flat height="100%">
        <v-card-title>
            <v-layout>
                <v-flex>
                    <span class="subheading font-weight-regular section-title--color">Keywords</span>
                </v-flex>
                <v-flex pr-0 v-if="multiViewsBtnStatus" text-xs-right style="margin-top: -12px; margin-right: -8px;">
                    <v-btn class="mr-0" :disabled="currentView === 1" flat icon color="bindezcolor"
                           @click="move('backward')"
                    >
                        <v-icon small>
                            fas fa-chevron-left
                        </v-icon>
                    </v-btn>
                    <v-btn class="ml-0" :disabled="currentView === totalViews" flat icon color="bindezcolor"
                           @click="move('forward')"
                    >
                        <v-icon small>
                            fas fa-chevron-right
                        </v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card-title>
        <div v-if="keywordsFilter.length < 1" class="d-flex align-center fill-height" style="height: 300px;">
                <span class="text-xs-center subheading font-weight-bold"
                      style="color:#AFBAC8;">
                    No keyword to filter.
                </span>
        </div>
        <v-list v-if="summaryReady" style="max-height: 290px; margin-top: -15px;">
            <v-list-tile v-for="keyword in keywordsPerView" :key="keyword[0]">
                <v-list-tile-action style="margin-right: -5px; min-width: 32px;">
                    <v-checkbox
                            @change="postFilter"
                            class="checkbox--small custom-checkbox-size"
                            hide-details
                            v-model="selectedKeywords"
                            :ripple="false"
                            color="bindezcolor"
                            :value="keyword[0]"
                            :disabled="!monitorActionReady"
                    ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h4 class="body-1 font-weight-medium zawgyi" style="max-width:12px;">
                            {{keyword[0] | fontConvert | formatKeyword }}</h4>
                    </v-list-tile-title>
                </v-list-tile-content>
                <v-tooltip top>
                    <template slot="activator" slot-scope="{on}">
                        <v-chip
                                v-on="on"
                                color="bindezcolor"
                                text-color="#fff"
                                label
                                small
                        >
                            {{keyword[1] | abbrNumber}}
                        </v-chip>
                    </template>
                    <span>{{keyword[1] | formatNumber}}</span>
                </v-tooltip>
            </v-list-tile>
        </v-list>
        <div v-if="!summaryReady" style="height: 290px;">
            <v-layout fill-height align-center>
                <v-flex text-xs-center>
                    <v-progress-circular indeterminate color="bindezcolor"></v-progress-circular>
                </v-flex>
            </v-layout>
        </div>
    </v-card>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
	import rabbit from 'rabbit-node'
    import multiViews from '@/mixins/multiViews'
    import authCurrentUser from "@/mixins/authCurrentUser";
    import _cloneDeep from 'lodash/cloneDeep';
    import _chunk from 'lodash/chunk';
	export default {
		name: "KeywordsFilter",
		props: {
			keywordsFilter: {
				required: true,
				type: Array,
                default(){
					return []
                }
			}
		},
        mixins: [multiViews, authCurrentUser],
		computed: {
			...mapState([
				'monitorActionReady'
            ]),

			...mapState('mention', [
				'summaryReady'
			]),

			selectedKeywords: {
				get() {
					return this.$store.state.mention.selectedKeywords
				},
				set(value) {
					this.setSelectedKeywords(value);
				}
			},
		},
		methods: {
			...mapMutations('mention', [
				'setSelectedKeywords'
			]),

			postFilter() {
				this.$ua.trackEvent("Filter Post", "check", `${this.authenticatedUser.email || 'User'} filter post by keywords`);
				this.$emit("postFilter");
			}
		},
		filters: {
			fontConvert(text) {
				return rabbit.uni2zg(text)
			},
		},
		watch: {
			keywordsFilter: {
				handler(data) {
					let keywords = _cloneDeep(data);
					this.totalViews = Math.ceil(keywords.length / 6);
					this.allKeywords = _chunk(keywords, 6);
					this.keywordsView = this.allKeywords[0];
				},
				immediate: true
			}
		}

	}
</script>

<style scoped>

    .v-input--selection-controls__input i.v-icon.theme--light.material-icons {
        font-size: 6px;
    }

    .v-list__tile__action {
        min-width: 40px;
    }

</style>
